export class GeoSection {

    constructor(modelSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.modelSection = modelSection ?? null;
        this.elevationOfZeroDatumLevel = data.elevationOfZeroDatumLevel ?? null;
        this.notes = data.notes ?? null;
        this.geoTypes = data.geoTypes ?? [];
        this.layers = data.layers ?? [];
        this.waterBodies = data.waterBodies ?? [];

    }

}
